import { css } from '@emotion/core'
import { colors, font, measures, spacing } from 'styles/variables'
import * as MQ from 'styles/media-queries'

const { unit } = measures

export const mainWrapper = css`
  display: flex;
  align-items: center;
  justify-content: center;
  ${MQ.DESKTOPS} {
    height: ${16 * unit}px;
  }
`

export const wrapperColumn = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

export const wrapperRowCenter = css`
  display: flex;
  align-items: center;
  justify-content: center;
`

export const wrapperTimeZoneText = css`
  display: flex;
  justify-content: center;
  margin-bottom: ${unit}px;
  > span {
    color: ${colors.white60};
  }
`

export const textStyles = css`
  font-weight: ${font.weight.medium};
  font-size: ${spacing(1.75)};
`
